module.exports = __webpack_public_path__ + "static/img/13.72397f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/13.png
// module id = TuoQ
// module chunks = 0